import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { PrecisionPricingStatusType, PrecisionPricingType } from "./types"

export interface GetPrecisionPricingRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    startDate: string
    propertyId: string
    prequoteRequestId: string
    dayCount: number
    noOfAdults: number
    noOfChildren: number
    noOfPets: number | null
    petsAllowed: boolean
    displayPrice?: boolean
    allInPricing?: boolean
    searchSaveAmount?: number | null
  }
}

interface GetPrecisionPricingResponseData extends ResponseData {
  data: PrecisionPricingType
}

export interface GetPrecisionPricingResponse extends AxiosResponse {
  data: GetPrecisionPricingResponseData
}

export function getPrecisionPricingApi(
  { params }: GetPrecisionPricingRequest,
  axiosInstance: AxiosInstance,
): Promise<GetPrecisionPricingResponse> {
  const url = `/property/precision-pricing`
  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<GetPrecisionPricingResponse>
}

export interface GetPrecisionPricingStatusRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    propertyId: string
  }
}

interface GetPrecisionPricingStatusResponseData extends ResponseData {
  data: PrecisionPricingStatusType
}

export interface GetPrecisionPricingStatusResponse extends AxiosResponse {
  data: GetPrecisionPricingStatusResponseData
}

export function getPrecisionPricingStatusApi(
  { params }: GetPrecisionPricingStatusRequest,
  axiosInstance: AxiosInstance,
): Promise<GetPrecisionPricingStatusResponse> {
  const url = `/property/precision-pricing-status`
  return axiosInstance({
    params,
    method: "get",
    url,
  }) as Promise<GetPrecisionPricingStatusResponse>
}
